import { _ as _define_property } from "@swc/helpers/_/_define_property";
import React from 'react';
import { connectMediaStore } from '../../../_hocs/withOwnReduxStore';
import { compose } from 'redux';
import { selectors } from '../../../../Stream';
import { withTranslation } from 'react-i18next';
import LoadingIndicator from '@wix/da-ds/pkg/LoadingIndicator';
import { getBrowseDeviationStreamId } from '../../../helpers';
import DeviationSelector from '../';
import SearchInput from '../../../_partials/SearchInput';
import PopupInnerLayout from '../../../_partials/PopupInnerLayout';
import SelectedItemsPanel from '../../../_partials/SelectedItemsPanel';
import { getDeviationsByIds } from '../../../../redux/deviations/selectors';
import withSearch from '../../../_hocs/withSearch';
import NoSearchResults from '../../../_partials/NoSearchResults';
import { fetchMoreBrowseDeviations } from '../../../actions';
import { getSearchQuery } from '../../../selectors';
import { withMobileContext } from '@wix/da-react-context/pkg/MobileContext';
const enhance = compose(connectMediaStore((state)=>{
    const streamId = getBrowseDeviationStreamId(getSearchQuery(state));
    return {
        deviations: getDeviationsByIds(state, selectors.getItems(state, streamId)),
        isFetching: selectors.isFetching(state, streamId),
        hasMore: selectors.hasMore(state, streamId),
        isInitialized: selectors.isInitialized(state, streamId)
    };
}, {
    fetchMoreBrowseDeviations
}), withSearch, withMobileContext, withTranslation());
export class BrowseDeviationSelector extends React.Component {
    render() {
        return /*#__PURE__*/ React.createElement(PopupInnerLayout, {
            headerExtrasBottomZone: /*#__PURE__*/ React.createElement(SelectedItemsPanel, null),
            headerExtrasRightZone: /*#__PURE__*/ React.createElement(SearchInput, null),
            scrollableContent: this.renderContent(),
            onScrolledToBottom: this.fetchMoreIfNeeded,
            onNotScrollable: this.fetchMoreIfNeeded
        });
    }
    constructor(...args){
        super(...args);
        _define_property(this, "fetchMoreIfNeeded", ()=>{
            const { hasMore, isFetching } = this.props;
            if (!hasMore || isFetching) {
                return;
            }
            this.props.fetchMoreBrowseDeviations();
        });
        _define_property(this, "renderContent", ()=>{
            const { isInitialized, isFetching, deviations, searchQuery, hasMore } = this.props;
            if (searchQuery && !deviations.length && isInitialized && !isFetching) {
                return /*#__PURE__*/ React.createElement(NoSearchResults, null);
            }
            return /*#__PURE__*/ React.createElement(React.Fragment, null, isInitialized && deviations.length > 0 && /*#__PURE__*/ React.createElement(DeviationSelector, {
                deviations: deviations
            }), (!isInitialized || isFetching) && /*#__PURE__*/ React.createElement(LoadingIndicator, {
                view: "daSymbol",
                coverMode: !hasMore
            }));
        });
    }
}
export default enhance(BrowseDeviationSelector);
